<mat-dialog-content class="modal-content">
    <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="text-2xl font-extrabold tracking-tight">{{this.data?.businessPartner?.name}}</div>
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
            <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChange($event)" />
            </mat-form-field>
            <!--<button mat-icon-button color="primary" matTooltip="Mostrar filtro">
                <mat-icon svgIcon="filter_list"></mat-icon>
            </button>-->
        </div>
    </div>
    <div class="flex flex-auto overflow-hidden flex-col">
        <div class="container mt-0 flex-auto flex-col overflow-x-auto">
            <div class="sticky top-0 z-10 dark:bg-gray-900">
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                    [dataSource]="dataSourceBusinessPartnerSubRoutes" matSort>
                    <!--<ng-container matColumnDef="nro">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Nro</th>
                        <td mat-cell *matCellDef="let element;" class="px-6 text-left">
                            
                        </td>
                    </ng-container>-->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Rutas</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left">
                            {{element?.name}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="frequencies">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Frecuencia</th>
                        <td mat-cell *matCellDef="let element; let i = index" class="px-6 text-left">
                            <div style="display: flex; align-items: left; gap: 8px;">
                                <div style="display: flex; flex-direction: column; align-items: left;">
                                    <span style="min-height: 24px;">{{element.bpDaysInAllFrecuencies || '-'}}</span>
                                    <div style="display: flex; justify-content: left; gap: 8px; align-items: baseline;">
                                        <span>D({{element.bpDayFrecuenciesLength}})</span>
                                        <button mat-button color="primary"
                                            [disabled]="element.bpCustomFrecuenciesLength===0"
                                            (click)="openCustomFrequenciesModal(element)"
                                            style="padding: 0; min-width: auto; line-height: inherit; margin: 0;">
                                            A({{element.bpCustomFrecuenciesLength}})
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left"></th>
                        <td mat-cell *matCellDef="let element; let i = index" class="px-6 text-left">
                            <button color="warn" mat-icon-button
                                (click)="onDeleteSubRouteByBussinessPartner(i, element)">
                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                            </button>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
                </table>
                <div *ngIf="this.dataSourceBusinessPartnerSubRoutes.data.length === 0"
                    class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para
                    mostrar.
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
</mat-dialog-actions>